import React from "react";
import logoblack from "../../../images/logo_white.png";
import { MoonLoader } from "react-spinners";

export default function ConsultantLoading() {
  return (
    <div className="cosultant-loading-page" style={{}}>
      <div style={{}}>
        <MoonLoader
          loading={true}
          color="grey"
          size={150}
          cssOverride={{ translate: "0px  190px" }}
        />
        <img src={logoblack} width={"750rem"}></img>
      </div>
    </div>
  );
}
